import React from 'react';
import { createStructuredSelector } from 'reselect';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import session from 'lib/session';
import Icon from 'components/Icon';
import { actions } from 'modules/admin';

import styles from './styles.css';
import './dialpad.global.css';

const DialpadChat = ({ isAuthenticated }) => {
  return (
    <>
      <div
        id="kpd_koopidtag"
        data-kpdtag="Welcome_108968"
        data-kpdprovemail="5841433476481024@maropost.com"
        data-kpdguest="true"
        data-kpdembedded="true"
        data-kpdwfvars="
        customer.session.custname=${full_name},
        customer.session.custemail=${email},
        customer.session.custphone=${phone}
      "
      >
        {isAuthenticated && (
          <div className={styles.dialpadChat}>
            <Icon name="chat" width={24} height={24} />
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  isAuthenticated: session.isAuthenticated,
});

export default compose(
  connect(mapStateToProps, actions),
  withProps(({ isAuthenticated }) => isAuthenticated)
)(DialpadChat);
